function StationCreateController($scope, $filter, $state, PageHeading, StationComponent, CityComponent, AppConstants, Toast) {
	'ngInject';

	const vm = this;
	vm.createStation = createStation;
	vm.selectItemFromAutoComplete = selectItemFromAutoComplete;
	vm.stationItems = {'translations': []};
	vm.languages = AppConstants.languages;
	vm.searchCities = CityComponent.searchCities;
	vm.getResultSearchCities = CityComponent.getResultSearchCities;
	vm.clearResults = CityComponent.clearResultSearchCities;
	vm.getPaginationInfo = StationComponent.getPaginationInfo;

	activate();

	function activate() {
		const heading = $filter('translate')('HEADING.CREATING_NEW_STATION');
		const title = `BTMS | ${$filter('translate')('TITLE.NEW_STATION')}`;

		PageHeading.setPageHeading(heading, title);

		// build station object
		vm.languages.forEach(function(lang) {
			vm.stationItems.translations.push({'lang': lang, 'name': '', 'description': ''});
		});
	}

	/**
	 *  When is chosen city from a autoComplete input.
	 *  We setting vm.query(name of item) and station.city_id(id of item),
	 *  station model will be sending for create new station.
	 * @param city
	 */
	function selectItemFromAutoComplete(city) {
		vm.stationItems.city_id = city.id;
		vm.query = city.translation.name;
	}

	/**
	 *  Create new city
	 *
	 * @param station
	 */
	function createStation(params) {
		let hasErrors = false;

		angular.forEach($scope.createStation.$error.required, function() {
			hasErrors = true;

			return false;
		});

		if (hasErrors) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		StationComponent.createStation(params)
			.then(function(res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.CREATE_STATION'));
					$state.go('app.private.stations.list');
				}
			});
	}

}

export default StationCreateController;



/** WEBPACK FOOTER **
 ** ./client/private/stations/create/create.controller.js
 **/